/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Tools_Everyone_NoteInputs */



/**
* | output |
* | --- |
* | "Applies to every member. Per-user and per-team exceptions are not configured here." |
*
* @param {Integrations_Apis_Tools_Everyone_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_tools_everyone_note = /** @type {((inputs?: Integrations_Apis_Tools_Everyone_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Tools_Everyone_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gilt für alle Mitglieder. Ausnahmen pro Benutzer oder Team werden hier nicht konfiguriert.")
	return /** @type {LocalizedString} */ ("Applies to every member. Per-user and per-team exceptions are not configured here.")
});